import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { IMAGES, WHATSAPP_URL } from "@/lib/site";
import { Reveal } from "@/components/motion/Reveal";

export default function About() {
  return (
    <section id="about" className="relative py-20 md:py-32 bg-offwhite overflow-hidden" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <Reveal>
            <p className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-petrol mb-5">About Us</p>
            <h2 className="font-display font-extrabold text-ink text-3xl md:text-5xl tracking-tight leading-[1.08] mb-7">
              A home services business,<br className="hidden md:block" /> built by one family.
            </h2>
            <div className="space-y-5 text-ink/75 font-light text-base md:text-lg leading-relaxed max-w-xl">
              <p>
                C Duarte Home Pro is a true family effort. <span className="font-medium text-ink">André</span> leads the
                handyman and repair side — small repairs, flooring, painting and general maintenance.
              </p>
              <p>
                His <span className="font-medium text-ink">wife and daughter</span> lead the cleaning side, keeping homes,
                apartments and commercial spaces spotless — with André's support whenever it's needed.
              </p>
              <p>
                Everyone works together with the same care and dedication we'd give our own home. That's the difference
                between a job and a family standard.
              </p>
            </div>
            <div className="mt-9 flex items-center gap-3 text-petrol">
              <Heart className="h-5 w-5 text-mustard fill-mustard" />
              <span className="font-display font-semibold">Care & dedication, on every job.</span>
            </div>
          </Reveal>

          <Reveal delay={0.15} className="relative">
            {/* Offset mustard block */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="absolute -bottom-6 -left-6 md:-bottom-8 md:-left-8 h-40 w-40 md:h-56 md:w-56 rounded-3xl bg-mustard -z-0"
            />
            <div className="absolute -top-5 -right-5 h-24 w-24 rounded-2xl border-2 border-petrol/20 -z-0" />
            <div className="relative overflow-hidden rounded-[28px] clip-corner shadow-[0_30px_60px_rgba(22,52,69,0.18)]">
              <img src={IMAGES.family} alt="The C Duarte family" className="w-full h-[420px] md:h-[560px] object-cover" />
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-cta"
                className="absolute bottom-5 left-5 right-5 rounded-2xl bg-offwhite/90 backdrop-blur px-5 py-4 flex items-center justify-between hover:bg-offwhite transition-colors duration-300"
              >
                <span className="font-display font-bold text-petrol">Let's talk about your home</span>
                <span className="text-mustard font-bold">→</span>
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
